import { Cartesian3, ReferenceFrame, Matrix3, Transforms, } from "cesium";
import { UNITS_DEF, } from "../../Entities";
export const degToRad = (deg) => {
    return (deg * Math.PI) / 180;
};
export const radToDeg = (rad) => {
    return (rad * 180) / Math.PI;
};
export const EARTH_RADIUS = 6371.001;
export function meters2km(m) {
    return m / 1000;
}
export function km2meters(km) {
    return km * 1000.0;
}
const km2m = 1000;
export const parseValueWithUnits = (value, definedUnits) => {
    if (definedUnits === UNITS_DEF.DEG)
        return degToRad(value);
    if (definedUnits === UNITS_DEF.KM)
        return km2m * value;
    if (definedUnits === UNITS_DEF.KM2 ||
        definedUnits === UNITS_DEF.KM2_S ||
        definedUnits === UNITS_DEF.KM2_S2)
        return km2m ** 2 * value;
    if (definedUnits === UNITS_DEF.GM)
        return km2m ** 3 * value;
    return value;
};
export const getParsedValue = (data, definedUnits) => {
    if (!!!data)
        return 0;
    if (typeof data === "number")
        return parseValueWithUnits(data, definedUnits);
    const units = (data === null || data === void 0 ? void 0 : data.units) ? data.units : definedUnits;
    return parseValueWithUnits(data.value, units);
};
export const getStateVector = (sv) => {
    const parsedSv = {
        x: getParsedValue(sv.x, UNITS_DEF.KM),
        y: getParsedValue(sv.y, UNITS_DEF.KM),
        z: getParsedValue(sv.z, UNITS_DEF.KM),
        xDot: getParsedValue(sv.xDot ? sv.xDot : sv.vx, UNITS_DEF.KM),
        yDot: getParsedValue(sv.yDot ? sv.yDot : sv.vy, UNITS_DEF.KM),
        zDot: getParsedValue(sv.zDot ? sv.zDot : sv.vz, UNITS_DEF.KM),
    };
    return parsedSv;
};
export const getStateVectorWithEpoch = (sv) => {
    const parsedSv = {
        epoch: sv.epoch,
        x: getParsedValue(sv.x, UNITS_DEF.KM),
        y: getParsedValue(sv.y, UNITS_DEF.KM),
        z: getParsedValue(sv.z, UNITS_DEF.KM),
        xDot: getParsedValue(sv.xDot ? sv.xDot : sv.vx, UNITS_DEF.KM),
        yDot: getParsedValue(sv.yDot ? sv.yDot : sv.vy, UNITS_DEF.KM),
        zDot: getParsedValue(sv.zDot ? sv.zDot : sv.vz, UNITS_DEF.KM),
    };
    return parsedSv;
};
export const parseXml = (src) => {
    const parser = new DOMParser();
    return parser.parseFromString(src, "text/xml");
};
export const getKeplerianElementsFromObject = (keplerianElements) => {
    const { semiMajorAxis, eccentricity, inclination, raOfAscNode, argOfPericenter, anomaly, } = keplerianElements;
    const kep = {
        a: getParsedValue(semiMajorAxis, UNITS_DEF.KM),
        e: eccentricity,
        i: getParsedValue(inclination, UNITS_DEF.DEG),
        ω: getParsedValue(argOfPericenter, UNITS_DEF.DEG),
        Ω: getParsedValue(raOfAscNode, UNITS_DEF.DEG),
        M: getParsedValue(anomaly, UNITS_DEF.DEG),
    };
    return kep;
};
export const convertToReferenceFrame = (time, value, inputFrame, outputFrame, result) => {
    const scratchMatrix3 = new Matrix3();
    if (!value) {
        return value;
    }
    if (!result) {
        result = new Cartesian3();
    }
    if (inputFrame === outputFrame) {
        return Cartesian3.clone(value, result);
    }
    let icrfToFixed = Transforms.computeIcrfToFixedMatrix(time, scratchMatrix3);
    if (!icrfToFixed) {
        icrfToFixed = Transforms.computeTemeToPseudoFixedMatrix(time, scratchMatrix3);
    }
    if (inputFrame === ReferenceFrame.INERTIAL) {
        return Matrix3.multiplyByVector(icrfToFixed, value, result);
    }
    if (inputFrame === ReferenceFrame.FIXED) {
        return Matrix3.multiplyByVector(Matrix3.transpose(icrfToFixed, scratchMatrix3), value, result);
    }
    else {
        return new Cartesian3();
    }
};
//# sourceMappingURL=converters.js.map